var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#2CC1F1",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 5113 c-181 -29 -268 -56 -400 -125 -192 -99 -369 -276 -468 -468 -57 -110 -83 -182 -109 -300 -17 -80 -18 -174 -18 -1660 0 -1486 1 -1580 18 -1660 56 -259 193 -486 392 -647 142 -114 302 -190 485 -230 80 -17 174 -18 1660 -18 1486 0 1580 1 1660 18 183 40 343 116 485 230 199 161 336 388 392 647 17 80 18 174 18 1660 0 1486 -1 1580 -18 1660 -26 118 -52 190 -109 300 -149 288 -421 495 -758 576 -70 17 -169 18 -1640 20 -861 1 -1576 0 -1590 -3z m3190 -335 c163 -49 272 -111 374 -214 105 -104 170 -220 214 -379 16 -55 17 -195 17 -1625 0 -1708 4 -1586 -55 -1742 -66 -178 -260 -372 -438 -438 -156 -59 -34 -55 -1742 -55 -1708 0 -1586 -4 -1742 55 -177 66 -372 261 -438 438 -59 157 -55 28 -58 1697 -2 1132 0 1549 9 1605 52 336 303 597 639 665 52 11 364 13 1615 12 1416 -2 1555 -4 1605 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 3982 c-109 -39 -178 -112 -210 -221 -29 -102 4 -228 82 -306 122 -121 328 -121 450 0 121 122 121 328 0 450 -82 81 -219 114 -322 77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080 3680 l0 -160 960 0 960 0 0 160 0 160 -960 0 -960 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 2862 c-109 -39 -178 -112 -210 -221 -29 -102 4 -228 82 -306 122 -121 328 -121 450 0 121 122 121 328 0 450 -82 81 -219 114 -322 77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080 2560 l0 -160 960 0 960 0 0 160 0 160 -960 0 -960 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 1742 c-109 -39 -178 -112 -210 -221 -29 -102 4 -228 82 -306 122 -121 328 -121 450 0 121 122 121 328 0 450 -82 81 -219 114 -322 77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080 1440 l0 -160 960 0 960 0 0 160 0 160 -960 0 -960 0 0 -160z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity2);
export default __webpack_public_path__ + "static/media/Community2.83509ed069c069de4e844c422e7cdcd9.svg";
export { ForwardRef as ReactComponent };